import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux"
import { AiOutlineSetting, AiOutlineWarning } from "react-icons/ai";
import {
    Text,
    mergeStyleSets,
    MessageBar,
    MessageBarType,
    registerIcons,
} from "@fluentui/react";
import ApiSpinner from "../../common/ApiSpinner";
import "../../nominations/NominationList.css";
import * as LineHandlingStore from "../../../store/LineHandlingStore";
import * as SofViewStore from "../../../store/SofViewStore";
import * as SelectedTabStore from "../../../store/SelectedTabDataStore";
import * as ProcessFlowConfigStore from "../../../store/ProcessFlowConfigStore";
import * as GeneralStore from "../../../store/GeneralStore";
import { State } from "../../../store";
import clsx from "clsx";
import { NominationApi } from "../../../api/nominationApi";
import { useHistory } from "react-router-dom";
import '../tank.css';
import NominationItem from "./NominationItem";
import TankDisclaimer from "../TankDisclaimer";

type Props = SelectedTabStore.SelectedTabState &
    SofViewStore.SofViewState &
    GeneralStore.GeneralState &
    typeof LineHandlingStore.actionCreators &
    typeof ProcessFlowConfigStore.actionCreators &
    typeof SelectedTabStore.actionCreators &
    typeof SofViewStore.actionCreators &
    typeof GeneralStore.actionCreators;

const pageSize = 20;
const classes = mergeStyleSets({
    tab: {
        // borderBottom: "1px solid #E2E6E8",
    },
    mainDiv: {
        overflow: "hidden",
        height: "100%",
    },
    pivotItem: {
        display: "inline-block",
        marginLeft: "10px",
    },
    mainList: {
        overflowX: "hidden",
        overflowY: "scroll",
        maxHeight: "calc(100vh - 254px)",
        padding: "0",
        marginRight: "1px",
    },
    searcheBoxDiv: {
        position: "absolute",
        top: "5px",
        right: "5px",
        width: "25%",
    },
    dropDownDiv: {
        position: "absolute",
        top: "5px",
        right: "26%",
        width: "8%",
    },
    oval: {
        minwidth: "50px",
        minheight: "50px",
        background: "#4CAF50",
        borderRadius: "50%",
        fontSize: "small",
        padding: "1px 6px 2px 6px",
        color: "#FFF",
    },
    filterButton: {
        background: "#EDEDED",
        border: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "0 12px 0 12px",
        gap: "6px",
        color: "#4C4C4C",
        fontSize: "14px",
        fontWeight: "700",
        selectors: {
            ":focus": {
                outline: "none",
            },
        },
    },
    viewIcon: {
        color: "#4C4C4C",
        margin: "auto",
        display: "block",
    },
});

registerIcons({
    icons: {
        "custom-search-svg": (
            <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6.5 12.5C7.83123 12.4997 9.1241 12.0541 10.1728 11.234L13.4697 14.531L14.5303 13.4705L11.2333 10.1735C12.0538 9.12475 12.4997 7.83158 12.5 6.5C12.5 3.19175 9.80825 0.5 6.5 0.5C3.19175 0.5 0.5 3.19175 0.5 6.5C0.5 9.80825 3.19175 12.5 6.5 12.5ZM6.5 2C8.98175 2 11 4.01825 11 6.5C11 8.98175 8.98175 11 6.5 11C4.01825 11 2 8.98175 2 6.5C2 4.01825 4.01825 2 6.5 2Z"
                    fill="#4C4C4C"
                />
            </svg>
        ),
    },
});

const NominationListPage: FC<Props> = (props: Props) => {
    const [nominations, setNominations] = useState<any[]>([
        {
            nominationNo: 123, name: 'Tank 1125', updatedAt: '2024-07-30T08:36:00Z',
            criticalMeasurements: {
                "level": {
                    "displayName": "LIT-125-01",
                    "fieldName": "LIT-0125-0001",
                    "processValue": 63.797000885009766,
                    "setPoint": 50.0,
                    "hihiAlarm": {
                        "setPoint": 66.6240005493164,
                    },
                    "hiAlarm": {
                        "setPoint": 65.58499908447266
                    },
                    "loAlarm": {},
                    "loloAlarm": {},
                    "valueMin": 0.0,
                    "valueMax": 67.5
                }
            }, brand: 'Petron', chemical: 'Monoethylene glycol', mode: 'IDLE', temp_f: 86.94, temp_c: 6.58, temp_h: 1.48 },
        {
            nominationNo: 456, name: 'Tank 8975', updatedAt: '2024-06-25T15:00:00Z',
            criticalMeasurements: {
                "level": {
                    "displayName": "LIT-125-01",
                    "fieldName": "LIT-0125-0001",
                    "processValue": 65.797000885009766,
                    "setPoint": 50.0,
                    "hihiAlarm": {
                        "setPoint": 66.6240005493164,
                    },
                    "hiAlarm": {
                        "setPoint": 65.58499908447266
                    },
                    "loAlarm": {},
                    "loloAlarm": {},
                    "valueMin": 0.0,
                    "valueMax": 67.5
                }
            }, brand: 'Shell', chemical: 'Monoethylene glycol', mode: 'IDLE', temp_f: 76.94, temp_c: 5.58, temp_h: 0.58 },
        {
            nominationNo: 789, name: 'Tank 1546', updatedAt: '2024-07-30T01:00:00Z',
            criticalMeasurements: {
                "level": {
                    "displayName": "LIT-125-01",
                    "fieldName": "LIT-0125-0001",
                    "processValue": 23.797000885009766,
                    "setPoint": 50.0,
                    "hihiAlarm": {
                        "setPoint": 66.6240005493164,
                    },
                    "hiAlarm": {
                        "setPoint": 65.58499908447266
                    },
                    "loAlarm": {},
                    "loloAlarm": {},
                    "valueMin": 0.0,
                    "valueMax": 67.5
                }
            }, brand: 'Union', chemical: 'Monoethylene glycol', mode: 'IDLE', temp_f: 36.94, temp_c: 7.58, temp_h: 0.18 },
        {
            nominationNo: 321, name: 'Tank 1798', updatedAt: '2023-06-25T01:00:00Z',
            criticalMeasurements: {
                "level": {
                    "displayName": "LIT-125-01",
                    "fieldName": "LIT-0125-0001",
                    "processValue": 43.797000885009766,
                    "setPoint": 50.0,
                    "hihiAlarm": {
                        "setPoint": 66.6240005493164,
                    },
                    "hiAlarm": {
                        "setPoint": 65.58499908447266
                    },
                    "loAlarm": {},
                    "loloAlarm": {},
                    "valueMin": 0.0,
                    "valueMax": 67.5
                }
            }, brand: 'BP Chemicals', chemical: 'Monoethylene glycol', mode: 'ACTIVE', temp_f: 56.94, temp_c: 5.38, temp_h: 2.48 },
        {
            nominationNo: 654, name: 'Tank 1234', updatedAt: '2024-07-30T01:00:00Z',
            criticalMeasurements: {
                "level": {
                    "displayName": "LIT-125-01",
                    "fieldName": "LIT-0125-0001",
                    "processValue": 13.797000885009766,
                    "setPoint": 50.0,
                    "hihiAlarm": {
                        "setPoint": 66.6240005493164,
                    },
                    "hiAlarm": {
                        "setPoint": 65.58499908447266
                    },
                    "loAlarm": {},
                    "loloAlarm": {},
                    "valueMin": 0.0,
                    "valueMax": 67.5
                }
            }, brand: 'Union', chemical: 'Monoethylene glycol', mode: 'IDLE', temp_f: 36.94, temp_c: 7.58, temp_h: 0.18 },
        {
            nominationNo: 987, name: 'Tank 5678', updatedAt: '2024-05-25T12:00:00Z',
            criticalMeasurements: {
                "level": {
                    "displayName": "LIT-125-01",
                    "fieldName": "LIT-0125-0001",
                    "processValue": 33.797000885009766,
                    "setPoint": 50.0,
                    "hihiAlarm": {
                        "setPoint": 66.6240005493164,
                    },
                    "hiAlarm": {
                        "setPoint": 65.58499908447266
                    },
                    "loAlarm": {},
                    "loloAlarm": {},
                    "valueMin": 0.0,
                    "valueMax": 67.5
                }
            }, brand: 'BP Chemicals', chemical: 'Monoethylene glycol', mode: 'IDLE', temp_f: 56.94, temp_c: 5.38, temp_h: 2.48 },
        {
            nominationNo: 154, name: 'Tank 9123', updatedAt: '2024-07-25T15:40:00Z',
            criticalMeasurements: {
                "level": {
                    "displayName": "LIT-125-01",
                    "fieldName": "LIT-0125-0001",
                    "processValue": 1.797000885009766,
                    "setPoint": 50.0,
                    "hihiAlarm": {
                        "setPoint": 66.6240005493164,
                    },
                    "hiAlarm": {
                        "setPoint": 65.58499908447266
                    },
                    "loAlarm": {},
                    "loloAlarm": {},
                    "valueMin": 0.0,
                    "valueMax": 67.5
                }
            }, brand: 'Shell', chemical: 'Monoethylene glycol', mode: 'ACTIVE', temp_f: 76.94, temp_c: 5.58, temp_h: 0.58 },

    ]);
    const [modality, setModality] = useState(0);
    const [modalityName, setModalityName] = useState("marine");
    const [nextPage, setNextPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [isEndReached, setIsEndReached] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>();
    const [keyword, setKeyword] = useState<string>();
    const [salesOrg, setSalesOrg] = useState<string>();
    
    const history = useHistory();

    const removeScrolling = () => {
        const main = document.getElementById("div-nomination-list");
        if (main) {
            main.removeEventListener("scroll", trackScrolling);
        }
    };

    const trackScrolling = async () => {
        const main = document.getElementById("main-scroll");
        if (main) {
            const isBottom =
                main.getBoundingClientRect().bottom <= window.innerHeight;
            if (isBottom) {
                removeScrolling();
                setNextPage((prev) => prev + 1);
            }
        }
    };

    const loadItemsAsync = async (pageNo: number, searchString: string) => {
        try {
            //if (pageNo === 1) {
            //    setNominations([]);
            //}
            setErrorMessage(undefined);
            setIsLoading(true);
            let typeOfModality =
                history.location.pathname.indexOf("truck") > 0
                    ? 1
                    : history.location.pathname.indexOf("rail")
                        ? 2
                        : 0;
            if (history.location.pathname.indexOf("tank")) {
                typeOfModality = 3; // should be 3
            }
            const result = await NominationApi.getNominationListAsync(
                typeOfModality,
                props.selectedTab,
                getSalesOrg(),
                pageNo,
                pageSize,
                searchString
            );

            setIsLoading(false);

            const hasMorePages = Math.ceil(result.totalResults / pageSize) > pageNo;
            setIsEndReached(!hasMorePages);
            if (hasMorePages) {
                const wrappedElement = document.getElementById("div-nomination-list");
                if (wrappedElement)
                    wrappedElement.addEventListener("scroll", trackScrolling);
            } else {
                removeScrolling();
            }
        } catch (err) {
            setIsEndReached(true);
            setIsLoading(false);
        }
    };

    const getSalesOrg = () => {
        if (salesOrg) {
            return salesOrg;
        } else {
            return props.marineSalesOrg;
        }
    };


    useEffect(() => {
        if (getSalesOrg()) {
            loadItemsAsync(nextPage, keyword === undefined ? "" : keyword);
        }
    }, [nextPage]);

    useEffect(() => {
        if (getSalesOrg()) {
            setNextPage(1);
            //setNominations([]);
            loadItemsAsync(nextPage, keyword === undefined ? "" : keyword);
        }
    }, [props.selectedTab, props.marineSalesOrg, salesOrg]);

    useEffect(() => {
        props.getAllConfigs();
        props.deleteActiveLineHandling();
        props.deleteActiveNomination();
        props.deleteActiveConfig();
        return removeScrolling;
    }, []);

    useEffect(() => {
        if (window.location.pathname.indexOf("tank") > 0) {
            setModality(1);
            setModalityName("tank");
        }
    }, []);

    const capitalizeFirstLetter = (text: string) => {
        return text.charAt(0).toUpperCase() + text.slice(1);
    };

    return (
        <>
            <div className={classes.mainDiv}>
                <div
                    className="ms-Grid"
                    dir="ltr"
                    style={{ backgroundColor: "#F1F5F9", margin: "12px", padding: "0px" }}
                >
                    <div className="d-flex justify-content-between align-items-center" style={{ padding: "10px 20px" }}>
                        <div className="ms-Grid-col ms-md4">
                            <div className="font-weight-bold" style={{ fontSize: 24, lineHeight: "48px" }}>
                                {capitalizeFirstLetter(modalityName)} Listing
                            </div>
                        </div>
                        <button type="button" className="btn btn-light rounded-circle settings-button"><AiOutlineSetting /></button>
                    </div>
                    <div
                        id="div-nomination-list"
                        className={clsx(classes.mainList, "custom-scroll")}
                    >
                        <div id="main-scroll" dir="ltr">
                            {errorMessage && (
                                <MessageBar messageBarType={MessageBarType.error}>
                                    {errorMessage}{" "}
                                    <a
                                        onClick={() =>
                                            loadItemsAsync(
                                                nextPage,
                                                keyword === undefined ? "" : keyword
                                            )
                                        }
                                    >
                                        Click here to retry.
                                    </a>
                                </MessageBar>
                            )}

                            <div className="px-4">
                                <TankDisclaimer />
                            </div>
                            <div className="row px-4">
                                {nominations.map((nomination: any, index: number) => (
                                    <NominationItem nomination={nomination} key={index} />
                                ))}
                            </div>

                            {isEndReached && !isLoading && (
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-md12">
                                        <Text
                                            variant="small"
                                            block
                                            style={{ textAlign: "center", color: "#c4c4c4" }}
                                        >
                                            - End of list -
                                        </Text>
                                    </div>
                                </div>
                            )}
                            {isLoading && <ApiSpinner />}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default connect(
    (state: State) => (state: State) => ({
        ...state.selectedTab,
        ...state.general,
    }),
    {
        ...LineHandlingStore.actionCreators,
        ...ProcessFlowConfigStore.actionCreators,
        ...SofViewStore.actionCreators,
        ...SelectedTabStore.actionCreators,
        ...GeneralStore.actionCreators,
    }
)(NominationListPage as any);
